import { CompanyBody } from "@vviinn/user-managment-client-ts";
import { FormEvent, FC, useMemo } from "react";

import { useAppSelector, handleCompany } from "../../store";

import { useRequestHandlers } from "../../app/hooks/useRequestHandlers";

import { transformFormData } from "../../helpers";
import { DetailedWrapper } from "../../ui/layout/general/DetailedWrapper/DetailedWrapper";
import { NamedSelect } from "../../ui/layout/molecules/NamedSelect";
import { INPUT_FIELD_STYLES } from "../../ui/layout/detailedPages/styles";
import { sortUsers } from "../../user/helpers";
import { FormRow, SubSectionWithStyles } from "../../ui/layout";

export const CompanyNew: FC<React.PropsWithChildren> = () => {
  const company = useAppSelector((state) => state.company.company);
  const users = useAppSelector((state) => state.users.users);
  const backLink = "/companies";
  const handlerParams = useRequestHandlers();
  const { handleCreateNewCompany } = handleCompany(handlerParams);

  const handleFormSubmit = async (e: FormEvent) => {
    if (!company) return;
    const form = e.target as HTMLFormElement;
    const data = new FormData(form);
    const body = transformFormData<CompanyBody>(data);

    body.ownerId = `${body.ownerId ?? ""}`;
    const newCompanyId = await handleCreateNewCompany(body);
    if (newCompanyId) return `/company/${newCompanyId}`;
  };

  const sortedUsers = useMemo(() => sortUsers(users, "email"), [users]);

  return (
    <DetailedWrapper
      createItemAction={handleFormSubmit}
      backLink={backLink}
      detailedPageType="new"
      detailedPage="company"
    >
      <SubSectionWithStyles title="General Information" isSubHeader={false}>
        <FormRow labelText="Company Name" labelHtmlFor="name">
          <input
            type="text"
            name="name"
            id="name"
            required
            className={INPUT_FIELD_STYLES}
          />
        </FormRow>
        <NamedSelect
          title="Company Owner"
          customId="ownerId"
          options={sortedUsers.map(({ uid, email }) => ({
            value: uid,
            title: email,
          }))}
          required={true}
          styleVariant="newPage"
          capitalize={false}
        />
      </SubSectionWithStyles>
    </DetailedWrapper>
  );
};
